
import ModuleIcon from '@assets/icons/modules/items';
import {
  Column,
  Row,
  Spacer,
  Text
} from '@components/1-atoms';
import ListItem, { ListItemData, Props as ListItemProps, ListSectionHeader } from '@components/2-molecules/ListItem';
import styled, { css } from '@emotion/native';
import React, { FC } from 'react';
import { Platform, SectionList as RNSectionList, View } from 'react-native';

import _ from 'underscore';

interface Item extends ListItemData {
  id: string;
  name: string;
  description?: string;
}

type Section = { title: string; data: ReadonlyArray<Item> };

// Create a typed SectionList component
const SectionList = styled(RNSectionList<Item, Section>)``;

type Props = ListItemProps & {
  data?: any[];
  onPress?: (data: ListItemData) => void;
};

const ProductServiceList: FC<Props> = ({ data, onPress, ...props }) => {

  const sectionData = _.chain(data)
    .sortBy((productOrService) => productOrService.name)
    .groupBy(_.property(['name', 0]))
    .map((productsAndServices: any, key: string) => ({
      title: `${key}`,
      data: productsAndServices,
    }))
    // .value() unwraps the Underscore object to return the final result.
    .value();

  const _renderItem = ({ item }: { item: any, index: number }) => {
    return (
      <ListItem
        {...props} onPress={() => { onPress?.(item) }} sub={item.description}>
        <Text>{item.name}</Text>
      </ListItem>
    );
  };

  {/* Empty list message box */ }
  if (data?.length === 0) {
    return (
      <View>
        <Spacer h={3} />
        <Row style={{ justifyContent: 'center' }}>
          <ModuleIcon {...props} />
        </Row>
        <Spacer h={.9} />
        <Row>
          <Column>
            <Text align='center' {...props}>You can manage all your products </Text>
            <Text align='center' {...props}>here. Tap <Text large bold>⋮</Text> to create your first </Text>
            <Text align='center' {...props}>product.</Text>
          </Column>
        </Row>
        <Spacer h={3} />
      </View>);
  } else {
    return (
      <View>
        {/* <Input left={<Search/>} />
            <Spacer h={1} />
           */}

        {/* CASE 1: */}
        {/* The `AppTemplate` provides a main ScrollView that wraps all the page content. */}
        {/* This ScrollView's job is to allow the entire page content to scroll if its content */}
        {/* is taller than the screen. */}

        {/* This SectionList is itself a scrollable view. */}
        {/* However, nested while not supported in react-native is supported in react-native-web */}

        {/* CASE 2: */}
        {/* The SectionList tries to render with an infinite height, which causes the outer ScrollView */}
        {/* to think its content is infinitely tall. This breaks the layout, often causing the list to expand */}
        {/* and push everything below it off-screen, which is exactly the behavior you were seeing. */}

        {/* WARNINGS ⚠️ : The list has a infinite height when the following styles are removed.  */}
        {/*               The view contains the list inside its immediate container.*/}
        <View style={css(`width: 100%; height: auto; `)}>
          <SectionList
            scrollEnabled={(Platform.OS === 'web') ? true : false}
            sections={sectionData as Section[]}
            keyExtractor={(item: any) => item && `${item.id}`}
            renderItem={_renderItem}
            renderSectionHeader={({ section: { title } }) => <ListSectionHeader children={title.toUpperCase()} />}
            renderSectionFooter={() => <Spacer h={1} />}
          />
        </View>

      </View >
    );
  };

};

export default ProductServiceList;